import React, { useCallback, useState, useContext, useEffect } from 'react';
import UserUpdateSection from '../sections/user';
import GroupList from '../sections/groupList';
import BaseSectionContainer from '../containers/baseSectionContainer';
import { UserGroupContext } from '../../Licensing/userSetup';

interface Props {
  tableContainerStyle?: React.CSSProperties;
  setSelectedUsers: React.Dispatch<React.SetStateAction<any[]>>;
  selectedUsers: any[];
  setEditId: React.Dispatch<React.SetStateAction<number>>;
  editId: number;
}

const UserSection = (props: Props) => {
  const { tableContainerStyle, setSelectedUsers, selectedUsers, editId, setEditId } = props;
  const { tempState } = useContext(UserGroupContext);
  const onSelectedUserChange = useCallback(
    (userIndices) => {
      setSelectedUsers(tempState.users.filter((_v, _ix) => userIndices.includes(_ix)));
    },
    [tempState],
  );

  const updateSelectedUsers = useCallback(() => {
    setSelectedUsers((prv) => {
      const _userIds = prv.map((u) => u.id);

      return tempState.users?.filter((u) => _userIds.includes(u.id)) || [];
    });
  }, [tempState]);

  useEffect(() => updateSelectedUsers(), [tempState]);

  return (
    <BaseSectionContainer
      firstSection={
        <UserUpdateSection
          onSelectedUserChange={onSelectedUserChange}
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          tableContainerStyle={tableContainerStyle}
          editId={editId}
          setEditId={setEditId}
        />
      }
      secondSection={
        <GroupList selectedUser={selectedUsers.length > 1 ? null : selectedUsers[0]} />
      }
    />
  );
};

export default UserSection;
